import { IBookingCalendarStore } from '../index'

export default function(state: IBookingCalendarStore): IBookingCalendarStore {
  return {
    ...state,
    request: {
      ...state.request,
      isCalendarReady: true,
    },
  }
}
